// components/VersionUpdateAlert.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import './GenaralStyles/VersionUpdateAlert.scss';

const VersionUpdateAlert = () => {
  const { newVersionAvailable, latestVersion } = useSelector((state) => state.version);

  const handleRefresh = () => {
    // Marca que el usuario hizo refresh
    localStorage.setItem('lastVersionSeen', latestVersion);
    console.log('Debio guardar la nueva version:', latestVersion);
    window.location.reload(true);
  };

  if (!newVersionAvailable) return null;

  return (
    <div className="version-alert">
      <span>Hay una nueva versión de YGIA disponible.</span>
      <Button type="primary" size="small" onClick={handleRefresh}>
        Refrescar ahora
      </Button>
    </div>
  );
};

export default VersionUpdateAlert;
